const store = {
    path: 'akarsh-jairaj-processed-images',
    pathCompressed: 'akarsh-jairaj-processed-images-compressed',
    photographerUrl: "https://raw.githubusercontent.com/akarshjairaj/storage/master/projects/akarsh-jairaj/images/photographer.jpg"
}

export { store }